<template>
<div id="facturas_transito_transportista">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Carga CFDI Comercio Exterior" class="elevation-1 px-5 py-3">
                <br />
               
                 
                        <v-card class="elevation-1 px-5 py-3">

                            <v-card-text>
                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md>                                            
                                            <v-row wrap v-show="gruposTransportistas.length>0">
                                                <v-col cols="8">
                                                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado" 
                                                    :rules="[rules.required]" :item-text="getNombreGrupo" item-value="rfc" 
                                                    label="Seleccione Transportista" ></v-autocomplete>
                                                </v-col>                                                
                                            </v-row><br>
                                            <v-layout wrap>                                                
                                                <v-flex xs12>
                                                    <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' 
                                                        v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                    <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked">
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn@click.native="modal=false; reset();">
                                        <v-icon>cancel</v-icon> Cancelar</v-btn>
                                        <v-btn v-if="false" color="success">
                                            <v-icon>done</v-icon>Guardar
                                        </v-btn>
                                </v-card-actions>
                            </v-card-text>
                        </v-card>

             
                    
              

            </base-material-card>
        </v-flex>

    </v-container>
    


</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import moment from "moment";
import qrCode from 'qrcode';
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    computed: {
        datafiltered() {
            if (this.$refs['vuetabledetalle'] != null)
                return this.$refs.vuetabledetalle.allFilteredData;
            else
                return [];
        },
    },
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");

        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = this.$local_storage.get("rfc_grupo");  
            this.es_grupo = 1;
            this.getClientesTransportista();            
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
            this.getTransportistas();            
        }
        
        
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;

        
        
        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        es_grupo:0,
        gruposTransportistas:[],
        clientesTransportista:[],
        rfc_grupo_seleccionado:"",
        rfc_cliente_seleccionado:"",
        permisoEliminar: false,
        tab: null,
        qrSrc: null,
        data_table_impo: [],
        lista_filtrada: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            },
           
            {
                text: "Carga de CFDI",
                disabled: true,
                to: "",
            },
        ],

        update: false,

        file: "",
        cliente: "",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        loadingBtn:false,
        modalProforma: false,
        model_proforma: {
            transportista:'',
            hbl:'',
            contenedor:'',
            facturas:'',
            agente_carga:'',
        },

        to_download: [],
        dialog1: false,
        dialog2: false,
        listado: "",
        datos: [],
        datos_comercio: [],
        allChecked: false,
        columns: [
            "id",
            "fecha_solicitud",
            "usuario_email",
            "nombre_reporte",
            "criterio",
            "fecha_generacion",
            "estatus",
            "error",
            "actions",
        ],
        options: {
            filterable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],
            sortable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar",
            },
        },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        tiposComprobante:[{"nombre":"Ingreso"},{"nombre":"Egreso"},
            {"nombre":"Traslado"},{"nombre":"Nómina"},{"nombre":"Pago"}
        ],
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            tipo_comprobante:"",
            reporte_url: "/reportes_ws/consulta_adjuntos/",
            nombre_reporte: "Facturas en Tránsito",
            tipo: "Facturas Transito",
            tipo_reporte: "",
            archivo: "", //para buscar por nombre de adjunto
            integrado: 0
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        fecha_factura: false,
        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,
        data_resumen: [],
        data_resumen_excel: {
            "RFC Transportista": "rfc_grupo",
            RFC: "rfc",
            Fecha: "fecha",
            Usuario: "nombre_usuario",
            Archivo: "filename",
            "RFC factura": "rfc_factura",
            "Razon Social": "razon_social",
            Folio: "folio",
            "Fecha Emisión": "fecha_emision",
            "Tipo CFDI":"tipo_cfdi",
            "Importe":"importe",            

        },
        columns_resumen: [
            "rfc_grupo",
            "rfc",            
            "fecha",
            "iniciales",
            "filename",
            "rfc_factura",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",            
            "actions_view"
        ],
        options_resumen: {
            filterable: [
                "rfc_grupo",
                "rfc",
                "fecha",
                "iniciales",
                "filename",
                "rfc_factura",
                "folio",
                "fecha_emision",
                 "tipo_cfdi",
                "importe",                
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
                "rfc_grupo",
                "rfc",
                "fecha",
                "iniciales",
                "filename",
                "rfc_factura",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
                "importe",                
            ],
            headings: {
                "rfc_grupo":"RFC Transportista",
                "rfc":"RFC",
                fecha: "Fecha",
                iniciales: "Usuario",
                filename: "Archivo",
                rfc_factura: "RFC Factura",
                descripcion: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                "tipo_cfdi":"Tipo CFDI",
                "importe":"Importe",
                actions_view: 'Opciones'
            },
        },
    }),
    methods: {
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },
        getTransportistas: function(){            
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),                
            };
            axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;
                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getNombreCliente:function(row){
            if(row.metadato!=null && row.metadato!="")
                return row.rfc+" - "+row.metadato;
            else
                return row.rfc+" - "+row.razon_social;
        },
        getClientesTransportista: function(){
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),                
            };
            axios.post(this.$hostname+ "grupos/get_rfcs/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        cargarReportesDS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Transito_SinPedimento"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarReportesComercio: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Comercio_Exterior"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos_comercio = res.data;
                        this.datos_comercio.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos_comercio) {
                            this.datos_comercio[k].fecha_solicitud = this.parseDate(this.datos_comercio[k].fecha_solicitud);
                            this.datos_comercio[k].fecha_generacion = this.parseDate(this.datos_comercio[k].fecha_generacion);
                            this.datos_comercio[k].estatus = this.getEstatus(this.datos_comercio[k].estatus);
                            this.datos_comercio[k].criterio = this.getCriterioPredeterminadosDS(this.datos_comercio[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte== undefined && params.fecha_de!=undefined ){
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 1) {
                        return "Pedimento: " + params.pedimento;
                    } else if (params.tipo_reporte == 3) {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 4) {
                        return "Búsqueda por listado de pedimentos";
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        createObjectUrl(err, canvas) {
            if (!err) {
                canvas.toBlob((blob) => {
                    this.qrSrc = window.URL.createObjectURL(blob)
                })
            } else {
                console.warn('generateQrCode:ERROR', err)
            }
        },
        pickFile() {
            this.$refs.file_input.click()
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    
                    /*Se cambio para que lo suba directo a S3 y ya luego lo lea en la lambda*/
                    this.uploadFile(files[0], nombre[0]);
                    
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc_file = "";
            if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) 
                rfc_file = this.$local_storage.get("rfc_grupo");
            else {
                rfc_file = this.rfc_grupo_seleccionado; //Se supone que si es un cliente debe seleccionar el rfc del transportista
                if (rfc_file == null || rfc_file == ""){
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Debe seleccionar el transportista.",
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();
                    this.reset();
                    return false;
                }
            }

            var usuario_file = this.$local_storage.get("id_usuario");

            var keyFile = "bandeja_entrada/" + rfc_file + "/" + usuario_file + "/" + this.name_file;
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.type_file
            }
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {
                                headers: {
                                    'Content-Type': this.type_file
                                }
                            })
                            .then((res) => {
                                thisObj.submitFile(referencia, keyFile, rfc_file);
                            })
                            .catch((error) => {
                                this.$root.$dialogLoader.hide();
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },

        submitFile(referencia, keyFile, rfc) {
            let formData = {
                key: keyFile,
                filename: this.name_file,
                tipo: 'facturas_en_transito', //Por default
                rfc_grupo: rfc,
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };

            axios.post(this.$hostname + 'facturas_transportista/guardar_factura_transportista/', formData)            
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        verFacturaProforma: function(rfc, filename){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var datos = {
                archivo: filename,
                rfc: rfc
            };

            axios.post(this.$hostname + "reportes_ws/get_data_facturas_pedimentos/", datos)
            .then(response => {
                this.model_proforma = response.data;
                window.URL.revokeObjectURL(this.qrSrc)
                qrCode.toCanvas(this.model_proforma.QRText, {}, this.createObjectUrl)
                this.modalProforma = true;
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los datos de la factura.",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });

        },
        descargarFacturaProformaMETODOANTERIOR: function(){
            this.loadingBtn = true;
            var opt = {
                margin: [0.5, 0.1, 0.5, 0.1], //top, left, bottom, right
                //filename: "Factura_Proforma_"+this.model_proforma.facturas.factura+".pdf",
                filename: this.model_proforma["Folio Fiscal"]+".pdf",
                image: {
                    type: "jpeg",
                    quality: 1
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: [ "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait", //portrait, landscape
                    compress: false,
                }
            };

            var html = document.getElementById("facturaProforma");
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .save()
                .then(function (pdf2) {
                                    thisObj.loadingBtn = false;
                                })
        },
        downloadFacturaProforma: function(filename, intento=0){
            var nombreZip = filename.toString()+".pdf";
            var key = this.$local_storage.get("rfc")+"/reportes/"+nombreZip;
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }

            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if(intento > 3) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function(){
                                thisObj.downloadFacturaProforma(filename, intento+1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)
                        }

                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=3){
                        setTimeout(function(){
                            thisObj.downloadFacturaProforma(filename, intento+1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

        },
        descargarFacturaProforma: function(){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filename = this.model_proforma["Folio Fiscal"];
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                archivo: filename,
                reporte_url: "/reportes_ws/proforma_factura_transito/",
                nombre_reporte: "Proforma Factura en Transito",
                tipo: "Proforma_Factura_Transito",
                usuario: this.$local_storage.get("id_usuario"),
            };
            var thisObj = this;
            axios.post(this.$hostname + "reportes/save_reporte/", datos)
            .then(res => {
                setTimeout(function(){
                    thisObj.downloadFacturaProforma(filename, 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                } else {//Si es un timeout intentamos descargar el archivo
                    setTimeout(function(){
                        thisObj.downloadFacturaProforma(filename, 1);
                    }, 10000); //Damos tiempo para generar el zip (10 seg)
                }
                console.log(error);
            });
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        check_all: function () {
            let self = this;
            this.to_download = this.allChecked ?
                this.data_resumen.map((row) => self.model.rfc + "/" + row.folder + "/" + row.filename) : [];
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },

        validaLista: function () {
            if (this.model.fecha_de == "" && this.model.fecha_a == "") {
                if (this.model.lista != undefined && this.model.lista.length > 0)
                    return true
                else
                    return "La Fecha es requerida cuando no existe lista de ordenes de compra"
            }
            return true;
        },
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);

                    let c = "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

                    if (params.lista != undefined && params.lista.length > 0) {
                        c = " Orden: ";

                        params.lista.forEach(function (item) {
                            c += item + " | ";
                            console.log(item);
                        });
                    }

                    return c;

                } else {
                    return "N/A";
                }
            } catch (error) {
                return "N/A-error";
            }

        },
        getEstatus: function (estatus) {
            var arr_estatus = [
                "Pendiente",
                "Encolado",
                "Generado Correctamente",
                "Con Errores",
            ];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return "N/A";
        },

        download_files: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var data = {
                rfc: this.model.rfc,
                usuario: this.model.usuario,
                pedimento: this.model.pedimento,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                lista: this.model.lista,
                reporte_url: "/reportes/facturas_abiertas_zip/",
                nombre_reporte: "Zip Facturas en Tránsito Seleccionadas",
                tipo: "Facturas Transito",
                tipo_reporte: 2,
                keys: this.to_download
            };

            if (data.pedimento == '') delete(data['pedimento']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.lista == '' || data.lista == []) {
                delete(data['lista'])
            } else {
                if (data.tipo_reporte == 4) {
                    data['lista'] = this.get_array_lista(data['lista'])
                }
            }

            axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",
                    data: data
                })
                .then(response => {
                    this.to_download = [];
                    if (data.tipo_reporte == 4) {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                    }
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406) {
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },
        get_array_lista: function (cadena) {
            let data = cadena.split("\n");
            let newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim();
                newarr[i] = newarr[i].replace(',', '');
                newarr[i] = newarr[i].replace('.', '');
                let a = newarr[i].split("_");
            }

            return newarr;
        },
         generar_reporte_sqs(tipo_reporte) {
            if (!this.$refs.formreporte.validate()) {
                //Alguna operación o mensaje
            } else {

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = {
                    rfc: this.model.rfc,
                    usuario: this.model.usuario,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    reporte_url: "/reportes_ws/facturas_adjuntas_pedimentos_transito/",
                    nombre_reporte: "Facturas en Tránsito",
                    tipo: "Facturas_Transito_SinPedimento",
                    fecha_factura: this.fecha_factura,
                    tipo_comprobante: this.model.tipo_comprobante==null?"":this.model.tipo_comprobante,
                    tipo_listado: "uuid"
                };

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        data: data
                    })
                    .then(response => {

                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406) {
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportesDS();
                    });
            }
        },
        generar_reporte_sqs_comercio() {
           if (!this.$refs.formreportecomercio.validate()) {
               //Alguna operación o mensaje
           } else {

               this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
               var data = {
                   rfc: this.model.rfc,
                   usuario: this.model.usuario,
                   fecha_de: this.model.fecha_de,
                   fecha_a: this.model.fecha_a,
                   reporte_url: "/reportes_ws/facturas_comercio_exterior/",
                   nombre_reporte: "Facturas De Comercio Exterior",
                   tipo: "Facturas_Comercio_Exterior",
                   fecha_factura: this.fecha_factura,
                   tipo_comprobante: this.model.tipo_comprobante==null?"":this.model.tipo_comprobante,
                   tipo_listado: "uuid"
               };

               axios({
                       method: "post",
                       url: this.$hostname + "reportes/save_reporte/",
                       data: data
                   })
                   .then(response => {

                       this.$swal({
                           type: "success",
                           title: "Operación Exitosa",
                           text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                           footer: ""
                       });
                   })
                   .catch(error => {
                       let mensaje;
                       var titulo = "¡Operación no Permitida!";
                       var tipo = "error";
                       if (typeof error.response !== "undefined") {
                           mensaje = error.response.data.mensaje;
                           if (error.response.status == 406) {
                               titulo = "¡Ya existe un reporte en proceso!";
                               tipo = "info";
                           }
                       } else {
                           mensaje = "Ocurrió un error al generar el reporte";
                       }
                       this.$swal({
                           type: tipo,
                           title: titulo,
                           text: mensaje,
                           footer: ""
                       });
                   }).then(() => {
                       this.$root.$dialogLoader.hide();
                       this.cargarReportesComercio();
                   });
           }
       },
        
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {

            let rfc = this.model.rfc;
            let file = rfc + "/" + key;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "facturas.abiertas.econectpro.mx",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " +
                    idreporte +
                    "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id_reporte: idreporte,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_reporte/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargarReportesDS();
                            this.cargarReportesComercio();
                        });
                }
            });
        },
        setListValues: function () {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada.push(to_list[i]);
                }
            }
            this.dialog1 = !this.dialog1;
        },
        maxListaRule: function () {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            }

            return true;
        },
        getTiposDocumentos: function () {

            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
                .then(response => {
                    if (response.data != undefined) {
                        this.tiposDocumentos = response.data;
                        this.tiposDocumentos = this.tiposDocumentos.sort(function (a, b) {
                            return a.clave > b.clave;
                        });

                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de documento.",
                        footer: ""
                    });
                });
        },
        getNombreTipoDocumento: function (tipo) {
            var filtro = this.tiposDocumentos.filter(function (e) {
                return e.clave == tipo;
            });
            if (filtro.length > 0)
                return filtro[0].descripcion;
            else
                return '';
        },
        
                
    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    /* font-weight: bold;    */
    line-height : 12px;
}
#tablaGenerales >>> th, td {
    border: 0 solid white !important;
    vertical-align: top !important;
    text-align: left !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> th{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> td{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> td {
    font-size: 8px;
    text-align: center !important;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> th {
    font-size: 8px;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:3px !important;
    padding-bottom:3px !important;
}
</style>
